import Parse from "parse";
import { Product } from "../Models/ProductModel";
import { handleError } from "./ErrorHandler.ts";


export async function getProductList(): Promise<Product[]> {
  try {
    const products = await Parse.Cloud.run("productsList")
    return products as Product[]

  } catch (error) {
    handleError(error)
    throw error
  }
}